var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M15.368 4H4v11.368h11.368V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M15.368 16.632H4V28h11.368V16.632Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M28 4H16.63v11.368H28V4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M28 16.632H16.63V28H28V16.632Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.f59a2d635dddd85615e68e5c7e908902.svg";
export { ForwardRef as ReactComponent };